var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-data-table',{attrs:{"p-headers":_vm.headers,"p-title":"Produtos","p-read-link":"products.read.one","p-create-link":"products.create","p-name":"products"}})}
var staticRenderFns = []

export { render, staticRenderFns }